import { gql } from 'react-apollo';

export default gql`
  mutation commentunLike($commentId: ID) {
    commentunLike(commentId: $commentId) {
      _id

      content
      title
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/commentunLike.js